import styled from 'styled-components'

import { helpers } from 'styles'

export const Container = styled.footer`
	height: 72px;
	background-color: ${({ theme }) => theme.color.cardBackground};
	font-size: ${helpers.font.size.smaller};
	padding: 0 12px;
`
